import { render, staticRenderFns } from "./FloatingMediaPlayer.vue?vue&type=template&id=4b5fb3f6&scoped=true"
import script from "./FloatingMediaPlayer.vue?vue&type=script&lang=js"
export * from "./FloatingMediaPlayer.vue?vue&type=script&lang=js"
import style0 from "./FloatingMediaPlayer.vue?vue&type=style&index=0&id=4b5fb3f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5fb3f6",
  null
  
)

export default component.exports